import { Box, FormControlLabel, Grid, Radio, RadioGroup, Typography } from '@mui/material';
import { AnnouncementSectionProps } from '../validators/AnnouncementValidators';
import { OneTimeSchedule } from './OneTimeSchedule';
import { AnnouncementFrequencies } from '@inosio/payments-sdk';
import { AnnouncementState, selectAnnouncementsState } from '../sagas/announcementSlice';
import { useSelector } from 'react-redux';
import { RecurringSchedule } from './RecurringSchedule';
import { useState } from 'react';

export enum AnnouncementScheduleTypeStates {
  OneTime = 'one-time',
  Recurring = 'recurring',
}

interface IProps extends AnnouncementSectionProps {}

export const AnnouncementSchedule = (props: IProps) => {
  const { announcementDetail }: AnnouncementState = useSelector(selectAnnouncementsState);

  const [scheduleType, setScheduleType] = useState<AnnouncementScheduleTypeStates>(
    !announcementDetail.Frequency || announcementDetail.Frequency === AnnouncementFrequencies.OneTime ? AnnouncementScheduleTypeStates.OneTime : AnnouncementScheduleTypeStates.Recurring,
  );

  const handleFrequencyChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setScheduleType(event.target.value as AnnouncementScheduleTypeStates);
  };

  return (
    <Box>
      <Grid container spacing={0}>
        <Grid item xs={12} borderBottom="2px solid #EEEEEE" sx={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
          <Typography sx={{ fontWeight: 'bold', fontSize: '15px' }}>Type:</Typography>
          <RadioGroup row sx={{ marginLeft: 10 }} value={scheduleType} onChange={handleFrequencyChange}>
            <FormControlLabel value={AnnouncementScheduleTypeStates.OneTime} control={<Radio />} label="One-time" sx={{ fontSize: '12px' }} />
            <FormControlLabel value={AnnouncementScheduleTypeStates.Recurring} control={<Radio />} label="Recurring" sx={{ fontSize: '12px' }} />
          </RadioGroup>
        </Grid>
      </Grid>
      {scheduleType === AnnouncementScheduleTypeStates.OneTime && <OneTimeSchedule {...props} />}
      {scheduleType === AnnouncementScheduleTypeStates.Recurring && <RecurringSchedule {...props} />}
    </Box>
  );
};
